import HttpResponse from "../../../../../utils/http/http.response";

export enum UserDriverEditFormResponseFormOfEmployment {
  B2B = "B2B",
  EMPLOYMENT = "EMPLOYMENT",
}

export enum UserDriverEditFormResponseCitizenship {
  PL = "PL",
  DE = "DE",
  SK = "SK",
  CZ = "CZ",
  UA = "UA",
  RU = "RU",
  BY = "BY",
  LT = "LT",
}

export enum UserDriverEditFormResponseLanguage {
  PL = "PL",
  EN = "EN",
  DE = "DE",
  FR = "FR",
  ES = "ES",
  SK = "SK",
  CZ = "CZ",
  UA = "UA",
  RU = "RU",
  BY = "BY",
  LT = "LT",
}

export enum UserDriverEditFormResponseCarOwnership {
  OWNER = "OWNER",
  BUSINESS = "BUSINESS",
}

export type UserDriverEditFormResponseUser = {
  username: string;
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
  mobileSecondaryPrefix: string;
  mobileSecondary: string;
  email: string;
};

export type UserDriverEditFormResponseFleetPartner = {
  id: string;
  name: string;
};

export type UserDriverEditFormResponseTaxiCorporation = {
  companyName: string;
  displayName: string;
  id: string;
  fleetPartners: UserDriverEditFormResponseFleetPartner[];
};

export type UserDriverEditFormResponseAssociation = {
  id: string;
  contractType: UserDriverEditFormResponseFormOfEmployment;
  taxId: string;
  regon: string | null;
  krsNo: string;
  companyName: string;
  country: string;
  town: string;
  zipCode: string;
  street: string;
  houseNo: string;
  apartment: string;
  description: string | null;
  taxiCorporation: UserDriverEditFormResponseTaxiCorporation;
  fleetPartner: UserDriverEditFormResponseFleetPartner | null;
};

export type UserDriverEditFormResponseAddress = {
  lat: number;
  lon: number;
  country: string;
  town: string;
  zipCode: string;
  street: string;
  houseNo: string;
  apartment: string;
  description: string;
};

export type UserDriverEditFormResponseDriver = {
  birthDate: string;
  birthPlace: string;
  idNumber: string;
  citizenship: UserDriverEditFormResponseCitizenship;
  languages: UserDriverEditFormResponseLanguage[];
  experience: number;
  carOwnership: UserDriverEditFormResponseCarOwnership;
  carMake: string;
  carModel: string;
  carRegNo: string;
  carProdYear: number;
  carSeatsNo: number;
};

export type UserDriverEditFormResponseItem = {
  driver: UserDriverEditFormResponseDriver;
  user: UserDriverEditFormResponseUser;
  associations: UserDriverEditFormResponseAssociation[];
  startingAddress: UserDriverEditFormResponseAddress;
  mailingAddress: UserDriverEditFormResponseAddress;
};

type UserDriverEditFormResponse = HttpResponse<UserDriverEditFormResponseItem>;

export default UserDriverEditFormResponse;
